// The `next` query parameter the login and invitation pages redirect back
// to after sign-in.

/**
 * Reads the `next` query parameter from a search string and returns it only
 * when it is a same-origin path: it must start with `/` and not `//`, so a
 * crafted absolute URL cannot ride an authenticated redirect. Null otherwise.
 */
export function readNextParam(search: string): string | null {
  const params = new URLSearchParams(search);
  const raw = params.get("next");
  if (!raw) return null;
  if (!raw.startsWith("/")) return null;
  if (raw.startsWith("//")) return null;
  return raw;
}
